/**
 * TermsPage — 서비스 이용약관 (Issue #447 Phase F)
 *
 * F7 SPA의 정적 법적 문서 페이지. 비로그인 접근 가능.
 * 본문은 최소 골격만 두고 운영 단계에서 실 텍스트로 교체.
 */

import { Page, Navbar, Block, BlockTitle } from 'framework7-react';

export default function TermsPage() {
  return (
    <Page name="terms">
      <Navbar title="서비스 이용약관" backLink="Back" />

      <Block>
        <p>
          DISTILL을 이용하시기 전에 본 약관을 확인해 주십시오. 서비스 이용 시 본
          약관에 동의한 것으로 간주됩니다.
        </p>
      </Block>

      <BlockTitle>1. 서비스 내용</BlockTitle>
      <Block strong>
        <p>
          DISTILL은 사용자가 저장한 URL·메모를 AI로 요약하고 검색·채팅으로 탐색할 수
          있는 콘텐츠 큐레이션 서비스를 제공합니다.
        </p>
      </Block>

      <BlockTitle>2. 사용자 책임</BlockTitle>
      <Block strong>
        <p>
          저장한 콘텐츠의 저작권 준수, 계정 보안, 위법한 용도로의 사용 금지 책임은
          사용자에게 있습니다.
        </p>
      </Block>

      <BlockTitle>3. AI 요약의 한계</BlockTitle>
      <Block strong>
        <p>
          AI가 생성한 요약·답변은 부정확할 수 있으며, 중요한 의사결정에 그대로
          사용해서는 안 됩니다. 원문 확인 책임은 사용자에게 있습니다.
        </p>
      </Block>

      <BlockTitle>4. 서비스 변경·중단</BlockTitle>
      <Block strong>
        <p>
          운영자는 서비스의 일부 또는 전부를 사전 고지 후 변경하거나 중단할 수
          있습니다.
        </p>
      </Block>

      <BlockTitle>5. 면책</BlockTitle>
      <Block strong>
        <p>
          서비스 이용으로 발생한 손해에 대해 운영자는 고의 또는 중대한 과실이 없는
          한 책임지지 않습니다.
        </p>
      </Block>
    </Page>
  );
}
